var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item pb-3 mb-5 border-bottom",
      attrs: { id: "item-" + _vm.element.id }
    },
    [
      _c(
        "transition",
        { attrs: { mode: "out-in", name: "slide" } },
        [
          !_vm.isEdit
            ? _c(
                "div",
                { staticClass: "row" },
                [
                  _c("h2", { staticClass: "header__name col-12 col-md-8" }, [
                    _vm._v(
                      _vm._s(!_vm.online ? "Offline - " : "") +
                        _vm._s(_vm.element.headline)
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isEdit && _vm.element.price
                    ? _c(
                        "h2",
                        {
                          staticClass:
                            "font-weight-bold text-right col-12 col-md-4"
                        },
                        [_vm._v("€ " + _vm._s(_vm.element.price))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "col-12" }, [
                    _c("i", { staticClass: "fad fa-calendar-week" }),
                    _vm._v(
                      " Angebot gültig: " +
                        _vm._s(_vm.startDate) +
                        "\n                " +
                        _vm._s(_vm.endDate) +
                        " "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-12",
                    domProps: { innerHTML: _vm._s(_vm.element.description) }
                  }),
                  _vm._v(" "),
                  _c("buttons", {
                    attrs: { isLoading: _vm.isLoading },
                    on: {
                      delete: function($event) {
                        return _vm.deleteItem(_vm.item.id)
                      },
                      edit: function($event) {
                        _vm.isEdit = true
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEdit
            ? _c("buero-form", {
                attrs: {
                  elementValues: this.element,
                  schema: _vm.schema,
                  method: "patch",
                  url: "/api/merchant/offers"
                },
                on: { cancel: _vm.cancelEdit, updateItem: _vm.updateItem }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }